import PropTypes from 'prop-types';
import React from 'react';
import { Link } from '@bibliocommons/base-links';

import cardShape from 'app/shapes/cardShape';

import './EventLocation.scss';

export default function EventLocation({ card, trackClick }) {
  if (card.get('location')) {
    if (card.getIn(['location', 'url'])) {
      return (
        <Link
          href={card.getIn(['location', 'url'])}
          className="cp-event-location"
          dataKey="event-location-link"
          handleClick={() => trackClick({ linkText: card.getIn(['location', 'name']) })}
        >
          {card.getIn(['location', 'name'])}
        </Link>
      );
    }
    return <span className="cp-event-location">{card.getIn(['location', 'name'])}</span>;
  }

  return null;
}

EventLocation.defaultProps = {
  trackClick: () => {}
};

EventLocation.propTypes = {
  card: cardShape.isRequired,
  trackClick: PropTypes.func
};
